<template>
  <section class="px-6 md:max-w-2xl md:mx-auto">
    <slot/>
  </section>
</template>

<script>
export default {
  name: 'BaseSection',
};
</script>
